// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2165":"0becbacc772e6bc9","7938":"05c48543413bf6ca","8144":"7894cfdb9af869b1","8259":"57b64aa38d7e3a53","8552":"8487ce50197aa198"}[chunkId] + ".js";
};